import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import { CookbookTag, CookbookTagsResult } from '../types';
import CookbookTagsQuery from './CookbookTagsQuery';

type result = {
  loading: boolean;
  error?: ApolloError;
  mealTypeTags?: CookbookTag[];
};

interface ICookbookTagsConnectorApollo {
  children: (result: result) => React.ReactElement;
  dietTypeTags?: number[];
}

const CookbookTagsConnectorApollo: React.FC<ICookbookTagsConnectorApollo> = ({
  children,
  dietTypeTags,
}) => {
  const { loading, error, data } = useQuery<CookbookTagsResult>(CookbookTagsQuery, {
    variables: { dietTypeTags },
  });

  const result: result = {
    loading,
    error,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.mealTypeTags = data?.cookbook.tags.mealTypeTags;
  }
  return children(result);
};

export default CookbookTagsConnectorApollo;
